import React, { useState, useRef, useEffect, useCallback } from 'react';

const GALAXY_IMAGE = 'https://static.prod-images.emergentagent.com/jobs/e978b8c7-e204-4546-aebc-a4066c065784/images/eb28041e605266830b04e45b920fa37da75a54147cc9589cd60c56f04a4ab902.png';

// Star systems positioned as % of the galaxy image (0-100)
// Galaxy center is roughly at 45%, 48% in the image
const SYSTEMS = [
  // Deep Core
  { id: 'byss', name: 'Byss', x: 44, y: 46, region: 'Deep Core' },
  { id: 'tython', name: 'Tython', x: 46, y: 44, region: 'Deep Core' },
  
  // Core Worlds
  { id: 'coruscant', name: 'Coruscant', x: 45, y: 48, region: 'Core Worlds', major: true },
  { id: 'corellia', name: 'Corellia', x: 40, y: 50, region: 'Core Worlds', major: true },
  { id: 'alderaan', name: 'Alderaan', x: 38, y: 45, region: 'Core Worlds', major: true },
  { id: 'chandrila', name: 'Chandrila', x: 42, y: 52, region: 'Core Worlds' },
  { id: 'hosnian_prime', name: 'Hosnian Prime', x: 48, y: 53, region: 'Core Worlds' },
  
  // Colonies
  { id: 'cato_neimoidia', name: 'Cato Neimoidia', x: 35, y: 43, region: 'Colonies' },
  { id: 'fondor', name: 'Fondor', x: 50, y: 55, region: 'Colonies' },
  
  // Inner Rim
  { id: 'onderon', name: 'Onderon', x: 32, y: 40, region: 'Inner Rim' },
  { id: 'manaan', name: 'Manaan', x: 54, y: 38, region: 'Inner Rim' },
  { id: 'jakku', name: 'Jakku', x: 28, y: 48, region: 'Inner Rim' },
  
  // Mid Rim
  { id: 'naboo', name: 'Naboo', x: 52, y: 58, region: 'Mid Rim', major: true },
  { id: 'kashyyyk', name: 'Kashyyyk', x: 25, y: 39, region: 'Mid Rim', major: true },
  { id: 'malastare', name: 'Malastare', x: 50, y: 62, region: 'Mid Rim' },
  { id: 'bothawui', name: 'Bothawui', x: 28, y: 54, region: 'Mid Rim' },
  { id: 'takodana', name: 'Takodana', x: 34, y: 33, region: 'Mid Rim' },
  { id: 'ord_mantell', name: 'Ord Mantell', x: 38, y: 30, region: 'Mid Rim' },
  
  // Outer Rim
  { id: 'tatooine', name: 'Tatooine', x: 18, y: 54, region: 'Outer Rim', major: true },
  { id: 'geonosis', name: 'Geonosis', x: 20, y: 58, region: 'Outer Rim', major: true },
  { id: 'mustafar', name: 'Mustafar', x: 62, y: 65, region: 'Outer Rim', major: true },
  { id: 'mandalore', name: 'Mandalore', x: 24, y: 30, region: 'Outer Rim', major: true },
  { id: 'concordia', name: 'Concordia', x: 25, y: 29, region: 'Outer Rim' },
  { id: 'lothal', name: 'Lothal', x: 19, y: 38, region: 'Outer Rim' },
  { id: 'scarif', name: 'Scarif', x: 66, y: 60, region: 'Outer Rim' },
  { id: 'hoth', name: 'Hoth', x: 16, y: 32, region: 'Outer Rim', major: true },
  { id: 'dagobah', name: 'Dagobah', x: 64, y: 50, region: 'Outer Rim' },
  { id: 'endor', name: 'Endor', x: 68, y: 42, region: 'Outer Rim', major: true },
  { id: 'bespin', name: 'Bespin', x: 21, y: 28, region: 'Outer Rim' },
  { id: 'dathomir', name: 'Dathomir', x: 63, y: 34, region: 'Outer Rim' },
  { id: 'felucia', name: 'Felucia', x: 58, y: 30, region: 'Outer Rim' },
  { id: 'utapau', name: 'Utapau', x: 60, y: 26, region: 'Outer Rim' },
  { id: 'christophsis', name: 'Christophsis', x: 27, y: 60, region: 'Outer Rim' },
  { id: 'ryloth', name: 'Ryloth', x: 22, y: 44, region: 'Outer Rim' },
  { id: 'sullust', name: 'Sullust', x: 64, y: 56, region: 'Outer Rim' },
  { id: 'kessel', name: 'Kessel', x: 15, y: 40, region: 'Outer Rim' },
  { id: 'mygeeto', name: 'Mygeeto', x: 13, y: 26, region: 'Outer Rim' },
  { id: 'saleucami', name: 'Saleucami', x: 55, y: 24, region: 'Outer Rim' },
  { id: 'crait', name: 'Crait', x: 70, y: 48, region: 'Outer Rim' },
  { id: 'kamino', name: 'Kamino', x: 72, y: 68, region: 'Wild Space', major: true },
  { id: 'ilum', name: 'Ilum', x: 10, y: 22, region: 'Unknown Regions' },
  { id: 'ahch_to', name: 'Ahch-To', x: 8, y: 30, region: 'Unknown Regions' },
  { id: 'starkiller', name: 'Starkiller Base', x: 9, y: 20, region: 'Unknown Regions' },
  { id: 'exegol', name: 'Exegol', x: 44, y: 42, region: 'Unknown Regions' },
  // Additional systems
  { id: 'coruscant_underworld', name: 'Nar Shaddaa', x: 30, y: 46, region: 'Mid Rim' },
  { id: 'korriban', name: 'Korriban', x: 60, y: 68, region: 'Outer Rim' },
  { id: 'dantooine', name: 'Dantooine', x: 14, y: 36, region: 'Outer Rim' },
];

export { SYSTEMS };

// Parse BBY/ABY year to signed integer
function parseYear(position) {
  if (!position) return null;
  const p = String(position).trim().toUpperCase();
  try {
    if (p.includes('BBY')) return -parseInt(p.replace('BBY', '').trim(), 10);
    if (p.includes('ABY')) return parseInt(p.replace('ABY', '').trim(), 10);
    const n = parseInt(p, 10);
    return Number.isNaN(n) ? null : n;
  } catch (e) { return null; }
}

// Era-aware territory factions — drives which borders/labels render
function getFactionsForYear(year) {
  // Default to Clone Wars era if unknown
  if (year === null || year === undefined) year = -22;

  // Always-present territories
  const huttSpace = { id: 'hutt', label: 'HUTT SPACE', color: '168,85,247', // purple
    path: 'M18,48 Q22,52 26,56 Q22,60 18,58 Q15,54 18,48', textX: 21, textY: 54, fontSize: 1.1 };

  // Mandalorian Space — fades during Imperial occupation (post 19 BBY)
  const mandaloreActive = year < -19;
  const mandalore = { id: 'mandalore', label: 'MANDALORE', color: '20,184,166', // teal
    path: 'M22,26 Q26,24 30,26 Q32,30 28,33 Q24,32 22,28 Z', textX: 27, textY: 22, fontSize: 0.9,
    dim: !mandaloreActive };

  if (year < -22) {
    // ═══ Pre-Clone Wars: Republic + fractured Outer Rim warlords ═══
    return [
      { id: 'republic', label: 'GALACTIC REPUBLIC', color: '251,191,36', // gold
        path: 'M35,35 Q45,25 55,35 Q65,42 60,55 Q55,65 45,62 Q35,58 32,48 Z',
        textX: 45, textY: 30, fontSize: 1.6 },
      huttSpace, mandalore,
    ];
  }

  if (year >= -22 && year <= -19) {
    // ═══ Clone Wars: Republic vs CIS ═══
    return [
      { id: 'republic', label: 'GALACTIC REPUBLIC', color: '251,191,36',
        path: 'M35,35 Q45,25 55,35 Q65,42 60,55 Q55,65 45,62 Q35,58 32,48 Z',
        textX: 45, textY: 30, fontSize: 1.6 },
      { id: 'cis-west', label: 'C.I.S.', color: '239,68,68', // red
        path: 'M15,50 Q20,35 28,30 Q18,22 12,28 Q8,38 10,50 Q12,60 18,65 Q25,68 30,62 Q22,55 15,50',
        textX: 14, textY: 58, fontSize: 1.6 },
      { id: 'cis-east', label: 'C.I.S.', color: '239,68,68',
        path: 'M58,25 Q68,30 72,42 Q74,55 70,65 Q65,70 58,68 Q62,58 60,45 Q58,35 58,25',
        textX: 70, textY: 38, fontSize: 1.6 },
      huttSpace, mandalore,
    ];
  }

  if (year > -19 && year < 4) {
    // ═══ Imperial Era: Empire dominant + nascent Rebellion cells ═══
    return [
      { id: 'empire-core', label: 'GALACTIC EMPIRE', color: '229,231,235', // cold white/grey
        path: 'M32,30 Q45,20 58,28 Q70,35 68,52 Q60,65 48,66 Q35,65 28,55 Q24,42 32,30 Z',
        textX: 48, textY: 26, fontSize: 1.8 },
      { id: 'empire-east', label: 'IMPERIAL SECTOR', color: '229,231,235',
        path: 'M58,25 Q68,30 72,42 Q74,55 70,65 Q65,70 58,68 Q62,58 60,45 Q58,35 58,25',
        textX: 70, textY: 38, fontSize: 1.3 },
      { id: 'empire-west', label: 'IMPERIAL SECTOR', color: '229,231,235',
        path: 'M15,50 Q20,35 28,30 Q18,22 12,28 Q8,38 10,50 Q12,60 18,65 Q25,68 30,62 Q22,55 15,50',
        textX: 14, textY: 58, fontSize: 1.3 },
      // Rebel cells — small scattered orange pockets
      { id: 'rebel-yavin', label: 'REBEL CELL', color: '251,146,60', // orange
        path: 'M64,48 Q68,46 70,50 Q68,54 64,52 Z',
        textX: 67, textY: 55, fontSize: 0.95, dashed: true },
      { id: 'rebel-dantooine', label: 'REBEL CELL', color: '251,146,60',
        path: 'M12,34 Q16,32 18,37 Q16,40 12,38 Z',
        textX: 15, textY: 42, fontSize: 0.95, dashed: true },
      huttSpace, mandalore,
    ];
  }

  // ═══ Post Endor: New Republic + Imperial remnants ═══
  return [
    { id: 'new-republic', label: 'NEW REPUBLIC', color: '96,165,250', // blue
      path: 'M35,35 Q45,25 55,35 Q65,42 60,55 Q55,65 45,62 Q35,58 32,48 Z',
      textX: 45, textY: 30, fontSize: 1.6 },
    { id: 'imperial-remnant', label: 'IMP. REMNANT', color: '156,163,175', // grey
      path: 'M60,58 Q68,56 72,62 Q70,68 62,68 Q58,64 60,58 Z',
      textX: 66, textY: 71, fontSize: 1.1, dashed: true },
    huttSpace,
  ];
}

export default function GalaxyMap({ characterLocation, onSystemClick, worldCharacters = [], events = [], timelinePosition = '' }) {
  const containerRef = useRef(null);
  const [offset, setOffset] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [dragging, setDragging] = useState(false);
  const [dragStart, setDragStart] = useState(null);
  const [hoveredSystem, setHoveredSystem] = useState(null);
  const [imageLoaded, setImageLoaded] = useState(false);
  const [pulsePhase, setPulsePhase] = useState(0);

  // Pulse animation
  useEffect(() => {
    const interval = setInterval(() => setPulsePhase(p => (p + 1) % 100), 50);
    return () => clearInterval(interval);
  }, []);

  // Center on character location on first load
  useEffect(() => {
    if (characterLocation && imageLoaded && containerRef.current) {
      const sys = SYSTEMS.find(s =>
        s.id === characterLocation || s.name.toLowerCase() === characterLocation?.toLowerCase()
      );
      if (sys) {
        const rect = containerRef.current.getBoundingClientRect();
        const targetZoom = 2;
        setZoom(targetZoom);
        setOffset({
          x: -(sys.x / 100 * rect.width * targetZoom - rect.width / 2),
          y: -(sys.y / 100 * rect.height * targetZoom - rect.height / 2),
        });
      }
    }
  }, [characterLocation, imageLoaded]);

  // Mouse wheel zoom
  const handleWheel = useCallback((e) => {
    e.preventDefault();
    const container = containerRef.current;
    if (!container) return;
    const rect = container.getBoundingClientRect();
    const mouseX = e.clientX - rect.left;
    const mouseY = e.clientY - rect.top;
    
    const delta = e.deltaY > 0 ? 0.9 : 1.1;
    const newZoom = Math.max(0.5, Math.min(6, zoom * delta));
    
    // Zoom toward mouse position
    const scale = newZoom / zoom;
    setOffset(prev => ({
      x: mouseX - scale * (mouseX - prev.x),
      y: mouseY - scale * (mouseY - prev.y),
    }));
    setZoom(newZoom);
  }, [zoom]);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;
    el.addEventListener('wheel', handleWheel, { passive: false });
    return () => el.removeEventListener('wheel', handleWheel);
  }, [handleWheel]);

  // Click-hold drag
  const handleMouseDown = (e) => {
    if (e.target.closest('.system-dot')) return;
    setDragging(true);
    setDragStart({ x: e.clientX - offset.x, y: e.clientY - offset.y });
  };

  const handleMouseMove = (e) => {
    if (!dragging || !dragStart) return;
    setOffset({
      x: e.clientX - dragStart.x,
      y: e.clientY - dragStart.y,
    });
  };

  const handleMouseUp = () => {
    setDragging(false);
    setDragStart(null);
  };

  const charSystem = characterLocation ? SYSTEMS.find(s =>
    s.id === characterLocation || s.name.toLowerCase() === characterLocation?.toLowerCase()
  ) : null;

  const pulseScale = 1 + Math.sin(pulsePhase * 0.12) * 0.4;
  const pulseOpacity = 0.5 + Math.sin(pulsePhase * 0.08) * 0.3;

  return (
    <div
      ref={containerRef}
      className="w-full h-full overflow-hidden relative bg-black"
      style={{ cursor: dragging ? 'grabbing' : 'grab' }}
      onMouseDown={handleMouseDown}
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
      onMouseLeave={handleMouseUp}
      data-testid="galaxy-map"
    >
      {/* Galaxy image */}
      <div
        className="absolute will-change-transform"
        style={{
          transform: `translate(${offset.x}px, ${offset.y}px) scale(${zoom})`,
          transformOrigin: '0 0',
          width: '100%',
          height: '100%',
          transition: dragging ? 'none' : 'transform 0.1s ease-out',
        }}
      >
        <img
          src={GALAXY_IMAGE}
          alt="Galaxy"
          className="w-full h-full object-cover select-none pointer-events-none"
          draggable={false}
          onLoad={() => setImageLoaded(true)}
          style={{ opacity: imageLoaded ? 1 : 0, transition: 'opacity 0.5s' }}
        />

        {/* Territory borders — dynamic based on era */}
        {imageLoaded && (
          <svg className="absolute inset-0 w-full h-full pointer-events-none" viewBox="0 0 100 100" preserveAspectRatio="none">
            <defs>
              {/* Glow filter for territory borders + labels */}
              <filter id="territory-glow" x="-20%" y="-20%" width="140%" height="140%">
                <feGaussianBlur stdDeviation="0.6" result="blur" />
                <feMerge>
                  <feMergeNode in="blur" />
                  <feMergeNode in="SourceGraphic" />
                </feMerge>
              </filter>
            </defs>
            {getFactionsForYear(parseYear(timelinePosition)).map((f) => {
              const opacityMul = f.dim ? 0.55 : 1;
              return (
                <g key={f.id}>
                  {/* Dark underlay stroke — ensures visibility against bright galaxy core */}
                  <path
                    d={f.path}
                    fill="none"
                    stroke="rgba(0,0,0,0.7)"
                    strokeWidth={f.dashed ? 0.85 : 1.2}
                    strokeLinejoin="round"
                  />
                  {/* Glow layer */}
                  <path
                    d={f.path}
                    fill={`rgba(${f.color},${0.12 * opacityMul})`}
                    stroke={`rgba(${f.color},${0.95 * opacityMul})`}
                    strokeWidth={f.dashed ? 0.5 : 0.75}
                    strokeDasharray={f.dashed ? '0.6 0.6' : '1.2 0.6'}
                    strokeLinejoin="round"
                    filter="url(#territory-glow)"
                  />
                  {/* Label — black underlay for contrast */}
                  <text
                    x={f.textX}
                    y={f.textY}
                    textAnchor="middle"
                    fill="rgba(0,0,0,0.85)"
                    stroke="rgba(0,0,0,0.85)"
                    strokeWidth={0.25}
                    fontSize={f.fontSize}
                    fontFamily="monospace"
                    fontWeight="bold"
                    letterSpacing="0.1"
                  >
                    {f.label}
                  </text>
                  <text
                    x={f.textX}
                    y={f.textY}
                    textAnchor="middle"
                    fill={`rgba(${f.color},${0.95 * opacityMul})`}
                    fontSize={f.fontSize}
                    fontFamily="monospace"
                    fontWeight="bold"
                    letterSpacing="0.1"
                    filter="url(#territory-glow)"
                  >
                    {f.label}
                  </text>
                </g>
              );
            })}
          </svg>
        )}

        {/* System markers overlaid on the image */}
        {imageLoaded && SYSTEMS.filter(s => s.major).map(sys => {
          const isHovered = hoveredSystem === sys.id;
          const isCharHere = charSystem?.id === sys.id;
          const dotSize = sys.major ? 6 : 3;
          const color = sys.region === 'Core Worlds' ? '#fbbf24' :
                        sys.region === 'Deep Core' ? '#f59e0b' :
                        sys.region === 'Mid Rim' ? '#60a5fa' :
                        sys.region === 'Outer Rim' ? '#818cf8' :
                        sys.region === 'Unknown Regions' ? '#a78bfa' :
                        sys.region === 'Wild Space' ? '#6ee7b7' :
                        '#94a3b8';
          return (
            <div
              key={sys.id}
              className="system-dot absolute"
              style={{
                left: `${sys.x}%`,
                top: `${sys.y}%`,
                transform: 'translate(-50%, -50%)',
                zIndex: isHovered || isCharHere ? 20 : 10,
              }}
              onMouseEnter={() => setHoveredSystem(sys.id)}
              onMouseLeave={() => setHoveredSystem(null)}
              onClick={(e) => { e.stopPropagation(); onSystemClick?.(sys); }}
              data-testid={`system-${sys.id}`}
            >
              {/* Character beacon — pulsing rings */}
              {isCharHere && (
                <>
                  <div
                    className="absolute rounded-full"
                    style={{
                      left: '50%', top: '50%',
                      width: `${20 * pulseScale}px`, height: `${20 * pulseScale}px`,
                      transform: 'translate(-50%, -50%)',
                      border: '1px solid #60a5fa',
                      opacity: pulseOpacity * 0.5,
                    }}
                  />
                  <div
                    className="absolute rounded-full"
                    style={{
                      left: '50%', top: '50%',
                      width: `${32 * pulseScale}px`, height: `${32 * pulseScale}px`,
                      transform: 'translate(-50%, -50%)',
                      border: '1px solid #60a5fa',
                      opacity: pulseOpacity * 0.25,
                    }}
                  />
                  <div
                    className="absolute rounded-full bg-blue-400/20"
                    style={{
                      left: '50%', top: '50%',
                      width: '14px', height: '14px',
                      transform: 'translate(-50%, -50%)',
                    }}
                  />
                </>
              )}

              {/* System dot */}
              <div
                className="rounded-full cursor-pointer transition-all duration-150"
                style={{
                  width: `${isHovered ? dotSize + 4 : dotSize}px`,
                  height: `${isHovered ? dotSize + 4 : dotSize}px`,
                  backgroundColor: isCharHere ? '#60a5fa' : color,
                  boxShadow: `0 0 ${isHovered ? 12 : sys.major ? 8 : 4}px ${color}, 0 0 ${isHovered ? 20 : sys.major ? 12 : 0}px ${color}`,
                  opacity: 1,
                  border: sys.major ? `1px solid rgba(255,255,255,0.3)` : 'none',
                }}
              />

              {/* Label */}
              {(isHovered || (sys.major && zoom >= 1.2) || isCharHere) && (
                <div
                  className="absolute left-1/2 -translate-x-1/2 whitespace-nowrap pointer-events-none"
                  style={{ bottom: `${(isHovered ? dotSize + 8 : dotSize + 4)}px` }}
                >
                  <span
                    className="font-mono px-1.5 py-0.5 rounded"
                    style={{
                      fontSize: isHovered ? '11px' : '9px',
                      color: isCharHere ? '#93c5fd' : isHovered ? '#ffffff' : '#e2e8f0',
                      backgroundColor: isHovered ? 'rgba(0,0,0,0.85)' : 'rgba(0,0,0,0.55)',
                      fontWeight: isCharHere ? 'bold' : 600,
                      textShadow: '0 0 4px rgba(0,0,0,0.95), 0 1px 2px rgba(0,0,0,0.9)',
                      letterSpacing: '0.02em',
                    }}
                  >
                    {sys.name}
                  </span>
                </div>
              )}

              {/* Hover tooltip */}
              {isHovered && (
                <div
                  className="absolute left-full ml-2 top-1/2 -translate-y-1/2 bg-black/90 border border-blue-500/20 rounded px-2 py-1 whitespace-nowrap pointer-events-none z-50"
                  style={{ minWidth: '80px' }}
                >
                  <div className="text-[10px] font-mono text-slate-400">{sys.region}</div>
                  <div className="text-xs font-mono font-bold text-white">{sys.name}</div>
                  {isCharHere && <div className="text-[10px] font-mono text-blue-400 mt-0.5">You are here</div>}
                </div>
              )}
            </div>
          );
        })}

        {/* Galactic event markers */}
        {imageLoaded && events.map((evt, i) => {
          const sys = SYSTEMS.find(s =>
            s.id === evt.system_id || s.name?.toLowerCase() === evt.system_id?.toLowerCase()
          );
          if (!sys) return null;
          return (
            <div
              key={`evt-${i}`}
              className="absolute pointer-events-none"
              style={{
                left: `${sys.x}%`,
                top: `${sys.y}%`,
                transform: 'translate(-50%, -50%)',
                zIndex: 5,
              }}
            >
              <div
                className="rounded-full border-2 border-dashed border-red-400"
                style={{
                  width: '22px', height: '22px',
                  opacity: 0.6 + Math.sin(pulsePhase * 0.1 + i) * 0.3,
                  boxShadow: '0 0 8px rgba(248,113,113,0.6)',
                }}
              />
              <div
                className="absolute left-1/2 -translate-x-1/2 top-full mt-1 text-[9px] font-mono font-bold text-red-300 whitespace-nowrap px-1 rounded"
                style={{
                  backgroundColor: 'rgba(0,0,0,0.7)',
                  textShadow: '0 0 4px rgba(0,0,0,0.95)',
                }}
              >
                {evt.label}
              </div>
            </div>
          );
        })}

        {/* Other characters in the world */}
        {imageLoaded && worldCharacters.filter(c => c.location).map(char => {
          const sys = SYSTEMS.find(s =>
            s.id === char.location || s.name?.toLowerCase() === char.location?.toLowerCase()
          );
          if (!sys) return null;
          return (
            <div
              key={char.character_id}
              className="absolute pointer-events-none"
              style={{
                left: `${sys.x}%`,
                top: `${sys.y}%`,
                transform: 'translate(-50%, -50%)',
                zIndex: 15,
              }}
            >
              <div
                className="w-3.5 h-3.5 rounded-full border-2 border-orange-300"
                style={{
                  backgroundColor: 'rgba(251,146,60,0.4)',
                  boxShadow: '0 0 6px rgba(251,146,60,0.8)',
                }}
              />
              <div
                className="absolute left-1/2 -translate-x-1/2 top-full mt-1 text-[9px] font-mono font-bold text-orange-200 whitespace-nowrap px-1 rounded"
                style={{
                  backgroundColor: 'rgba(0,0,0,0.7)',
                  textShadow: '0 0 4px rgba(0,0,0,0.95)',
                }}
              >
                {char.name}
              </div>
            </div>
          );
        })}
      </div>

      {/* Zoom indicator */}
      <div className="absolute bottom-3 right-3 text-[10px] font-mono text-slate-600 bg-black/50 px-2 py-1 rounded pointer-events-none">
        {(zoom * 100).toFixed(0)}%
      </div>
    </div>
  );
}
